module.exports = __webpack_public_path__ + "static/media/bulkmint.fa8453f4.png";